export const LOCALE_COOKIE_KEY = 'site_i18n_current_locale'
export const LOCALE_PREFERENCE_MODE_KEY = 'site_i18n_locale_preference_mode'
export const LOCALE_TEMPLATE_KEY = 'site_i18n_locale_template_key'

export const LOCALE_PREFERENCE_MODES = {
  AUTO: 'auto',
  MANUAL: 'manual',
}

export function shouldApplyTemplateDefaultLocale({
  templateKey = '',
  defaultLocale = '',
  supportedLocales = [],
  currentLocale = '',
  preferenceMode = '',
  localeTemplateKey = '',
} = {}) {
  if (!defaultLocale) return false

  // Only templates with an explicit language policy replace a saved choice.
  // Australia's English UI must not revive partially translated Chinese CMS
  // headings beside English native pages when an older cookie is present.
  if (supportedLocales.length && !supportedLocales.includes(currentLocale)) return true

  const manual = preferenceMode === LOCALE_PREFERENCE_MODES.MANUAL && currentLocale
  const sameTemplate = preferenceMode === LOCALE_PREFERENCE_MODES.AUTO
    && currentLocale && localeTemplateKey && localeTemplateKey === templateKey
  return !manual && !sameTemplate
}
